import{decorateProperty as e}from"@lit/reactive-element/decorators/base.js";import{ContextConsumer as r}from"../controllers/context-consumer.js";
/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */function t({context:t,subscribe:o}){return e({finisher:(e,c)=>{e.addInitializer((e=>{new r(e,{context:t,callback:r=>{e[c]=r},subscribe:o})}))}})}export{t as consume};
//# sourceMappingURL=consume.js.map
